module.exports = __webpack_public_path__ + "static/media/chat-icon.2e42ab99.svg";